<template>
	<div>
		<buttonlist @help="help" @add="add" @search="search" @reflash="reflash"  @del="del"
					 @save="save" ref="SetBtn"></buttonlist>
		<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li class="left" ref="left">
				<el-table
						id="xpane-0"
						:data="dataSet"
						v-loading="loading"
						:highlight-current-row="false"
						show-overflow-tooltip="true"
						border
						stripe
						size="mini"
						:height="tableHeight"
						@row-click="editInfo"
						@row-dblclick="openEdit"
						tab-click="selectInfo(0)"
						header-row-class-name="headerclass"
						@selection-change="handleSelectionChange"
						style="width: 100%; margin-top:0px"
						:header-cell-style="$limits.headerClass"
						ref="singleTable"
				>
					<el-table-column show-overflow-tooltip prop="newitemname" :label="$t('getapi[12926]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="status" :label="$t('getapi[552]')" width="100">
						<template slot-scope="scope">
							{{expStatus(scope.row.status)}}
						</template>
					</el-table-column>
                    <el-table-column show-overflow-tooltip prop="bill_type" :label="$t('getapi[12936]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[2950]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="update_person" :label="$t('getapi[733]')" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="update_time" :label="$t('getapi[1210]')" width="100"></el-table-column>
				</el-table>
			</li>

			<li class="resize" ref="resize">
				<i class="el-icon-caret-right" @click="leftt(0)"></i>
				<i class="el-icon-caret-left" @click="leftt(1)"></i>
			</li>
			<!-- 右侧 -->
			<li class="mid" ref="mid">
				<div  style="float:right;position: relative;">
					<el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
				</div>
				<div>
					<el-button type="primary" size="mini" @click="audit" :disabled="dataDetail.Head.status != 0">{{ $t('getapi[941]') }}</el-button>
					<el-button type="primary" size="mini" @click="reAudit" :disabled="dataDetail.Head.status == 0">{{ $t('getapi[1334]') }}</el-button>
				</div>
				<div style="width:1000px;min-width:1000px">
					<table>
						<tr>
							<!--<td style="width:80px;min-width:80px"><span>{{ $t('getapi[12927]') }}</span></td>
							<td style="width:120px;min-width:120px">
								<el-input
										v-model="dataDetail.Head.newitemcode"
										type="text"
										class="mcolor"
										:disabled="dataDetail.Head.Order_status == 1 ? true : false"
										size="mini"
								>
									<i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectitem(scope)"></i>

								</el-input>
							</td>-->
							<td style="width:80px;min-width:80px"><span>{{ $t('getapi[12926]') }}</span></td>
							<td style="width:120px;min-width:120px">
								<el-input  size="mini" v-model="dataDetail.Head.newitemname" :readonly="dataDetail.Head.status != 0" :class="{'readO':dataDetail.Head.status != 0}"></el-input>
							</td>
							<td style="width:80px;min-width:80px"><span>{{ $t('getapi[552]') }}</span></td>
							<td style="width:120px;min-width:120px">
								<el-input :value="expStatus(dataDetail.Head.status)" :readonly="true" class="readO"
																			  size="mini"></el-input>
							</td>
                            <td style="width:160px;">
                                <div style="display: flex">
                                    <!-- @change="changempflag" -->
                                    <el-select
                                            v-model="dataDetail.Head.bill_type"
                                            :placeholder="$t('getapi[12936]')"
                                            size="mini"
                                            :readonly="dataDetail.Head.status != 0"
                                    >
                                        <el-option v-for="item in data_bill_type" :key="item.value" :label="item.label"
                                                   :value="item.value"></el-option>
                                    </el-select>
                                </div>
                            </td>
						</tr>
					</table>
				</div>
				<el-row>
					<div class="box" style="margin-top: 0px">
						<el-button type="primary" size="mini" @click="selectcus" :disabled="dataDetail.Head.status != 0">{{ $t('getapi[878]') }}
						</el-button>
						<el-button type="primary" size="mini" @click="batchDel" :disabled="selectData.length == 0 || dataDetail.Head.status != 0">{{ $t('getapi[1522]') }}
						</el-button>
					</div>
					<el-table
							id="xdetilpane-0"
							:data="dataDetail.Lists"
							v-loading="dloading"
							header-row-class-name="headerclass"
							:highlight-current-row="true"
							stripe
							border
							:height="tableHeight - 90"
							size="mini"
							@selection-change="handleSelectionChange"
							:row-class-name="tableRowClassName"
							style="width: 100%; margin-top:2px"
							ref="singleTable1"
					>
						<el-table-column type="selection"></el-table-column>
						<el-table-column show-overflow-tooltip prop="customer_id" :label="$t('getapi[12928]')" width="120"></el-table-column>
						<el-table-column show-overflow-tooltip prop="customer_name" :label="$t('getapi[12929]')" width="220"></el-table-column>
					</el-table>
				</el-row>
			</li>
		</ul>

		<el-row class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
					}}
				</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="CusItemRelation" ref="ser" @getser="serclick"></serce>

		<selector :isVisible="false" :isBatch=true :isSplitPage=true :postUrl="'/Sal/CusItemRelation/GetSalCustomerDataList'" @callback="getcus"
				  ref="cus"></selector>

		<selector :isVisible="false" :isBatch=false :isSplitPage=true :selectType="5"  :postUrl="'/Basic/Popup/GetEngItemDataList'"
				  @callback="getitem" ref="item"></selector>

	</div>
</template>

<script>
    import Common from '@/components/Common';
    import { Loading } from 'element-ui';
    export default {
        name: 'cusitemrelation',
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('cusitemrelation'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dloading:false,//右边明细表 加载状态
                tableHeight: Common.tableHeight3, // 主表高度
                user: '',
                dataDetail: {
                    Head: {},
                    Lists: []
                }, // 数据详情
                oldDataDetail:'',
                addoredit: -1,
                rowindex: -1,
                btn: {

                },
                code: '', // 数据唯一号
                selectData:[],
                oldrow: '',
                iscontinuedblclick:true,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                data_bill_type: [
                    {
                        value: 0,
                        label: this.$t('getapi[12933]')//'国外半导体'
                    },
                    {
                        value: 1,
                        label: this.$t('getapi[12934]')//'国内半导体'
                    },
                    {
                        value: 2,
                        label: this.$t('getapi[12935]')//'其他'
                    },
                    {
                        value: 3,
                        label: this.$t('getapi[12985]')//'轨道交通类'
                    },
                    {
                        value: 4,
                        label: this.$t('getapi[12986]')//'非轨道交通类'
                    },
                ],
            };
        },
        created:function(){
            //console.log('create------------')
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('cusitemrelation', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12925]"),this.$t("getapi[11]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.exclusively_id) && that.dataDetail.Head.status == 0) {
                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,del')
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh')
				}
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
            },
            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            getitem(data) {
                let that = this;
                console.log(data)
                that.dataDetail.Head.newitemname = data.item_name;
                that.dataDetail.Head.newitemcode = data.item_code;
            },
            selectcus() {
                let that = this;
                that.$refs.cus.clearInput(true);
            },
            getcus(data) {
                let that = this;
                console.log(data)
                data = data.filter(item => {
                    return that.dataDetail.Lists.every(item2 => {
                        return item.customer_id + item.customer_name != item2.customer_id + item2.customer_name;
                    });
                });
                for (let i = 0; i < data.length; i++) {
                    that.dataDetail.Lists = [
                        ...that.dataDetail.Lists,
                        {
                            exclusively_id: '',
                            relation_id: that.dataDetail.Head.exclusively_id,
                            customer_id: data[i].customer_id,
                            customer_name: data[i].customer_name,
                            create_person: '',
                            create_time: '',
                            update_person: '',
                            update_time: ''
                        }
                    ];
                }
            },
			//审核
            audit(){
                let that = this
				let parm = {
                    exclusively_id: that.dataDetail.Head.exclusively_id,
                    update_time: that.dataDetail.Head.update_time
				}
                that.$http.urlpost('/Sal/CusItemRelation/SalCusItemRelationAduit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                        that.getDetail(that.code)
                    }
                });
			},
			//反审
            reAudit(){
                let that = this
                let parm = {
                    exclusively_id: that.dataDetail.Head.exclusively_id,
                    update_time: that.dataDetail.Head.update_time
                }
                that.$http.urlpost('/Sal/CusItemRelation/SalCusItemRelationCancelAduit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                        that.getDetail(that.code)
                    }
                });
			},
            //查询右侧数据
            editInfo(e) {
                let that = this;
                if(that.code == e.exclusively_id){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = e
                                that.code = e.exclusively_id;
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = e
                        that.code = e.exclusively_id;
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            getDetail(data) {
                let that = this;
                let parm = {
                    Code:data,
                    LangType: that.$processdata.getLang()
				};
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Sal/CusItemRelation/GetSalCusItemRelationInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(0)
                        })
                    }
                    loadingInstance.close()
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            expStatus(val){
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[2663]')//'已审';
                } else {
                    return '';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('cusitemrelation',val)
                this.intidata();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.intidata();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'CusItemRelation');
            },
            //获取查询条件
            serclick(val) {
                this.pageIndex = 1;
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.intidata();
            },

            // 数据一览
            intidata() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost('/Sal/CusItemRelation/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 1;
                that.dataDetail = {
                    Head: {
                        exclusively_id: '',
                        newitemname: '',
                        newitemcode: '',
                        status: 0,
                        create_person: '',
                        create_time: '',
                        update_person: '',
                        update_time: '',
                        bill_type:0,
                    },
                    Lists: [],
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.intidata();
                            if(!that.$limits.fnIsEmpty(that.code)){
                                that.getDetail(that.code);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.intidata();
                    if(!that.$limits.fnIsEmpty(that.code)){
                        that.getDetail(that.code);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
            },
            save() {
                let that = this;
                let parm = that.dataDetail
                that.$http.urlpost('/Sal/CusItemRelation/SaveSalCusItemRelation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum);
                    }
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            update_time: that.dataDetail.Head.update_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Sal/CusItemRelation/DelSalCusItemRelation', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata();
                                that.confirmAdd();
                                that.code = ''
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority();
            },
            batchDel(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.Head.exclusively_id,
                            update_time: that.dataDetail.Head.update_time,
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.selectData[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.selectData[i].exclusively_id,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Sal/CusItemRelation/DelSalCusRelationLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.getDetail(that.code);
                                }
                                else{
                                    that.getDetail(that.code);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            checkDataChange(){
                let that = this
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style lang="scss" scoped>
	span.title {
		width: 100%;
		display: flex;
		height: 40px;
		line-height: 40px;
	}

	span.title .el-switch {
		display: inline-block;
		margin: 8px 30px;
	}

	.box {
		width: 100%;
		.bbl {
			margin: 0px auto 10px;
			white-space: pre;
			span {
				margin-left: 20px;
				width: 70px;
				text-align: left;
				line-height: 20px;
				display: inline-block;
			}
		}
	}

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
